import intlHook from 'imports/core/api/useIntl';
import { Experiment as MarvelExperiment, Variant as MarvelVariant } from '@marvelapp/react-ab-test';
export default function ResumeLanguageSectionDropdownExperiment(props) {
  const { locale } = intlHook();
  if (!['fr', 'en', 'es'].includes(locale)) return props.children;
  return (
    <MarvelExperiment name="exp_resume_language_block_dropdown">
      <MarvelVariant name="control">{props.children}</MarvelVariant>
      <MarvelVariant name="autocomplete_languages">{props.children}</MarvelVariant>
    </MarvelExperiment>
  );
}
